
export default {
    MAIN: {
        AREA: '/area/add.srv',
        NOTICE: '/front/getNotice.srv'
    },
    FOCUS: {
        PICTURES: '/front/query.srv'
    },
    PRODUCT: {
        CATEGORY: 'category/list.srv',
		LIST: 'product/search.srv',
		HOT: 'product/hotwords.srv',
		DETAILS: 'product/queryForShow.srv',
		IMG: 'product/queryImages.srv',
        ADD: 'product/clickAdd.srv',
        GETLIST: 'product/getList.srv'
    },
    NEWS: {
        LIST: '/news/list.srv',
        DETAIL: '/news/query.srv'
    },
	PROFILE:{
        ServiceList: 'agency/getDistance.srv',//服务网点
        ServiceList2: 'market/getDistance.srv',//营销网点
		BANNER: '/front/query.srv',
		DETAIL: '/about/query.srv',
        QUESTION: '/consult/getReply.srv'
	},
	SOLUTION:{
    	TO_SUBMIT: '/solution/add.srv'
	}
}
